import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { SupportService } from 'src/app/shared/services/support/support.service';

@Component({
  selector: 'app-support-button',
  templateUrl: './support-button.component.html',
})
export class SupportButtonComponent {
  available$: Observable<boolean>;
  loading$: Observable<boolean>;

  constructor(private supportService: SupportService) {
    this.available$ = this.supportService.available$;
    this.loading$ = this.supportService.loading$;
  }

  openSupport(): void {
    this.supportService.openWidget();
  }
}
